// src/constants.js
export const BASE_URL = "";
export const USERS_URL = "/api/users";
export const ENTREPRISES_URL = "/api/entreprises";
export const FOURNISSEURS_URL = "/api/fournisseurs";
export const ARTICLES_URL = "/api/articles";
export const COMMANDES_URL = "/api/commandes";
export const ENVOI_CDE_URL = "/api/envoi-cde-fournisseur";
export const VEILLE_URL = "/api/veille";
export const TOP_VENTES_URL = "/api/top-ventes";
export const MENU_HINTS_URL = "/api/menu-hints";
export const MENU_LAYOUT_URL = "/api/menu-layout";
export const SMTP_CONFIG_URL = "/api/smtp-config";
export const REPORT_SUBSCRIPTIONS_URL = "/api/report-subscriptions";
export const TEAMS_URL = "/api/teams";
export const TASKS_URL = "/api/tasks";
export const NOTIFICATIONS_URL = "/api/notifications";